import gettext from "refractor/gettext";
export default gettext;